export enum GaCategory {
  EMPTY = '',
  IRONRIDGE_CALCULATOR = 'ironridge_calculator',
  IRONRIDGE_COURSES = 'courses',
  ENSTALL_ACADEMY = 'enstall_academy',
  ESDEC_ONSITE_APP = 'onsite_app',
  ESDEC_ONSITE_PAGE = 'onsite_page',
  CHAPTER_ACADEMY = 'chapter_academy',
  ENSTALL_ERP = 'enstall_erp',
  ECOFASTEN_DESIGN_ASSISTANT = 'design_assistant',
  ECOFASTEN_ACADEMY = 'ecofasten_academy',
  ECOFASTEN_INSIGHT = 'ecofasten_insight',
}
